import React from 'react';

import { makeStyles } from '@material-ui/core';

import { EmailSupportLink } from '../widgets/email-support-link';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    // subtracting 64px for the header and 100px because this is inside of PageContainer in main-app.tsx
    height: 'calc(100vh - 64px - 100px)',
    width: '100vw',
  },
}));

// Users are disabled by blocking them in auth0. If a blocked user logs in,
// they will be sent to this page and have no access to data.
// The generic contact your account admins message is used because this user does
// not have access to the account admin's email addresses.
// Blocked user logs are recorded in the Auth0 dashboard under monitoring.

export const BlockedUserPage = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className="typo-h4">Your user is disabled</div>
      <div className="typo-h6 u-margin-top">
        Contact one of your account admins or <EmailSupportLink /> to gain access to your account.
      </div>
    </div>
  );
};
